import React from "react";

interface DateFiltersProps {
  startDate: string;
  endDate: string;
  metasCount: number;
  hasFilterHandlers: boolean;
  onStartDateChange?: (value: string) => void;
  onEndDateChange?: (value: string) => void;
  onApplyFilter?: () => void;
}

export const DateFilters: React.FC<DateFiltersProps> = ({
  startDate,
  endDate,
  metasCount,
  hasFilterHandlers,
  onStartDateChange,
  onEndDateChange,
  onApplyFilter,
}) => {
  return (
    <div className="mx-auto mb-4 max-w-5xl px-4">
      <div className="rounded-lg border border-slate-600/40 bg-slate-800/60 p-2 shadow-lg sm:p-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-start sm:gap-4">
          <div className="flex items-center gap-2">
            <label className="min-w-[2.5rem] text-sm font-medium text-slate-300">
              De:
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => onStartDateChange?.(e.target.value)}
              disabled={!hasFilterHandlers}
              className="flex-1 rounded border border-slate-500/40 bg-slate-700/50 px-2 py-1.5 text-sm text-white focus:border-cyan-400 focus:outline-none disabled:cursor-not-allowed disabled:opacity-70 sm:flex-none"
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="min-w-[2.5rem] text-sm font-medium text-slate-300">
              Até:
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => onEndDateChange?.(e.target.value)}
              disabled={!hasFilterHandlers}
              className="flex-1 rounded border border-slate-500/40 bg-slate-700/50 px-2 py-1.5 text-sm text-white focus:border-cyan-400 focus:outline-none disabled:cursor-not-allowed disabled:opacity-70 sm:flex-none"
            />
          </div>
          <button
            type="button"
            onClick={onApplyFilter}
            disabled={!hasFilterHandlers}
            className="rounded bg-cyan-600/80 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-cyan-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Filtrar
          </button>
          <div className="text-sm text-slate-300">
            {metasCount} meta(s) encontrada(s)
          </div>
        </div>
      </div>
    </div>
  );
};
